import { uniq } from 'lodash'

export const FilterTypes = {
  broad: 'broad',
  narrow: 'narrow',
}

const commonCoreCurriculumToId = {
  Mathematics: 212,
  ELA: 213,
  Science: 215,
  'Social Studies': 236,
}

export const getFilterType = (filter) => {
  if (
    filter.standardIds?.length ||
    filter.questionType ||
    filter.depthOfKnowledge ||
    filter.authorDifficulty ||
    filter.collections?.length ||
    filter.status ||
    filter.tags?.length ||
    filter.authoredByIds?.length ||
    filter.createdAt ||
    filter.type ||
    (filter.curriculumId &&
      !Object.values(commonCoreCurriculumToId).includes(filter.curriculumId))
  ) {
    return FilterTypes.narrow
  }

  return FilterTypes.broad
}

/**
 * Normalizes search tags by removing duplicates and truncating to 64 characters
 * Used across ItemList and AddItems components for consistent search tag processing
 * @param {Array<string>} tags - Array of search tag strings
 * @returns {Array<string>} Normalized array of unique tags (max 64 chars each)
 */
export const normalizeSearchTags = (tags) => {
  return uniq(tags.map((t) => (t.length > 64 ? t.slice(0, 65) : t)))
}
